import { useEffect } from "react"
import { invariant } from "@holigral/shared/utils"
import LoadingScreen from "./LoadingScreen"
import { windowMessageType } from "@/auth"

type Props = {
  result: "success" | "error" | "cancelled"
  refreshToken?: string
  error?: string
}

export default function OAuthResult({ result, refreshToken, error }: Props) {
  useEffect(() => {
    const opener = window.opener as WindowProxy | undefined
    invariant(opener)

    opener.postMessage({
      type: windowMessageType,
      result,
      refreshToken,
      error,
    })

    window.close()
  }, [result, refreshToken, error])

  return <LoadingScreen />
}
